import moment from "moment";

export const filterText = (data, searchText, matchFields) => {
    const search = searchText.toLowerCase();

    return data?.filter(row => {
        // Special handling: if both lastModBy and lastModifiedTS are present in matchFields (author column)
        if (
            matchFields.includes('lastModBy') &&
            (matchFields.includes('lastModifiedTS') || matchFields.includes('lastModifiedDate'))
        ) {
            const lastModBy = row.lastModBy?.toLowerCase() || '';
            const lastModifiedTS = row.lastModifiedTS || row.lastModifiedDate;
            const lastModifiedTSString = lastModifiedTS ? lastModifiedTS.toString().toLowerCase() : '';
            const lastModifiedTSFormatted = lastModifiedTS ? moment(lastModifiedTS).utc().format('LLLL').toLowerCase() : '';
            return (
                lastModBy.includes(search) ||
                lastModifiedTSString.includes(search) ||
                lastModifiedTSFormatted.includes(search)
            );
        }

        // Default: check each field
        return matchFields.some(field => {
            // Special handling for lastModifiedTS (date field)
            if ((field === 'lastModifiedTS' || field === 'lastModifiedDate') && row[field]) {
                const formattedDate = moment(row[field]).utc().format('LLLL').toLowerCase();
                return (
                    formattedDate.includes(search) ||
                    row[field].toString().toLowerCase().includes(search)
                );
            }
            return row[field] && row[field].toLowerCase().includes(search);
        });
    });
};

export const filterSelect = (data, searchText, matchFields) => {
    const [unit1] = matchFields;
    if (!searchText) return data;
    return data?.filter(row => row[unit1] && row[unit1] === searchText)
}

export const filterBoolean = (data, searchText, matchFields) => {
    const [unit1] = matchFields;
    if (searchText === false) return data;
    return data.filter(row => row[unit1] && row[unit1] === searchText);
};

export const filterDate = (data, searchText, matchFields) => {
    const search = searchText.toLowerCase();
    return data?.filter(row =>
        matchFields.some(field => {
            if (field === 'lastModifiedDate' && row[field]) {
                return row[field].toString().toLowerCase().includes(search);
            }
            return row[field] && moment(row[field]).format('DD/MM/YYYY').toLowerCase().includes(search);
        })
    );
}

export const filterFactory = (colType) => {
    const filterFns = {
        text: (data, searchText, matchFields) => filterText(data, searchText, matchFields),
        select: (data, searchText, matchFields) => filterSelect(data, searchText, matchFields),
        boolean: (data, searchText, matchFields) => filterBoolean(data, searchText, matchFields),
        date: (data, searchText, matchFields) => filterDate(data, searchText, matchFields),
    };

    return filterFns[colType];
}

export const filterGrid = (data, searchText, type, matchFields) => {
    const filter = filterFactory(type);
    return filter(data, searchText, matchFields);
}

export const applyFilters = (filtersMap, initialState) => {
    return filtersMap.reduce((acc, filter) => {
        const { value, type, matchFields } = filter;

        if (!value || !type) return acc;

        return filterGrid(acc, value, type, matchFields);
    }, initialState);
}